// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CapabilitySetCapability
 */
export interface CapabilitySetCapability {
    /**
     * 
     * @type {string}
     * @memberof CapabilitySetCapability
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof CapabilitySetCapability
     */
    friendly_name: string;
    /**
     * 
     * @type {string}
     * @memberof CapabilitySetCapability
     */
    name: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CapabilitySetCapability
     */
    resource_types: Array<string>;
}

/**
 * Check if a given object implements the CapabilitySetCapability interface.
 */
export function instanceOfCapabilitySetCapability(value: object): value is CapabilitySetCapability {
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('friendly_name' in value) || value['friendly_name'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('resource_types' in value) || value['resource_types'] === undefined) return false;
    return true;
}

export function CapabilitySetCapabilityFromJSON(json: any): CapabilitySetCapability {
    return CapabilitySetCapabilityFromJSONTyped(json, false);
}

export function CapabilitySetCapabilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): CapabilitySetCapability {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'],
        'friendly_name': json['friendly_name'],
        'name': json['name'],
        'resource_types': json['resource_types'],
    };
}

export function CapabilitySetCapabilityToJSON(json: any): CapabilitySetCapability {
    return CapabilitySetCapabilityToJSONTyped(json, false);
}

export function CapabilitySetCapabilityToJSONTyped(value?: CapabilitySetCapability | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'description': value['description'],
        'friendly_name': value['friendly_name'],
        'name': value['name'],
        'resource_types': value['resource_types'],
    };
}
